import { render, staticRenderFns } from "./NewsList.vue?vue&type=template&id=cf4d8b40&scoped=true"
import script from "./NewsList.vue?vue&type=script&lang=js"
export * from "./NewsList.vue?vue&type=script&lang=js"
import style0 from "./NewsList.vue?vue&type=style&index=0&id=cf4d8b40&lang=scss&scoped=true"
import style1 from "./NewsList.vue?vue&type=style&index=1&id=cf4d8b40&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf4d8b40",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\workspace\\ysorder\\order_admin_client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cf4d8b40')) {
      api.createRecord('cf4d8b40', component.options)
    } else {
      api.reload('cf4d8b40', component.options)
    }
    module.hot.accept("./NewsList.vue?vue&type=template&id=cf4d8b40&scoped=true", function () {
      api.rerender('cf4d8b40', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/articlemanagement/NewsManagement/NewsList.vue"
export default component.exports